import { useState, useContext, useCallback } from 'react';
// Context
import { AuthContext } from 'context';
// Constants
import { DICTONARY } from 'const/Dictonary';
// Services
import adminService from 'services/admin';

// Utils
import { diccionarioVista } from '../utils/utils';
import {
  AlertaError,
  AlertaExito,
  AlertaSinRegistros,
  AlertaWarning,
  ValidacionConexion
} from 'utils/Alertas';
import empresasService from 'services/empresas';

export const useServicesGrupos = () => {
  const { logged } = useContext(AuthContext);

  // States Campos Listado de Recursos Adquiridos
  const [listaGrupos, setListaGrupos] = useState([]);
  const [isLoadingLista, setIsLoadingLista] = useState(true);

  const [grupos, setGrupos] = useState([]);
  const [isLoadingGrupos, setIsLoadingGrupos] = useState(true);

  // States Campos Listado de Empresas
  const [empresas, setEmpresas] = useState([]);
  const [isLoadingEmpresas, setIsLoadingEmpresas] = useState(true);
  const [empresaSeleccionada, setEmpresaSeleccionada] = useState(null);

  // States Paginacion
  const [rowCount, setRowCount] = useState(1);
  const [pagination, setPagination] = useState(DICTONARY.PAGINACION.DEFAULT);
  const [globalFilter, setGlobalFilter] = useState('');
  const [columnFilters, setColumnFilters] = useState([]);

  const ObtieneListaGrupos = async () => {
    setIsLoadingLista(true);

    if (!logged) {
      ValidacionConexion();
      return;
    }

    const query = {};

    let nombreGrupo = null;

    if (columnFilters) {
      columnFilters.forEach(filter => {
        if (filter.id === 'nombreGrupo') {
          nombreGrupo = filter;
        }
      });
    }

    if (nombreGrupo) {
      query.nombreGrupo = nombreGrupo.value;
    }

    if (pagination) {
      Object.assign(query, {
        numPagina: pagination.pageIndex,
        totalPagina: pagination.pageSize
      });
    }

    // if (!isSuperAdmin) {
    //   query.codigoEmpresa = sucursal?.empresa?.codigoEmpresa;
    // }

    try {
      const response = await adminService.getGrupos(query);

      if (response.status === 200) {
        const { content, totalElements, empty } = response.data;
        if (empty) {
          console.log(
            `No hay ${diccionarioVista.nombreSingular} disponibles ::>`
          );

          throw new Error('SIN_REGISTROS');
        } else if (Array.isArray(content)) {
          // console.log('content :>> ', content);
          setListaGrupos(content);
          setRowCount(totalElements);
        }
      }
    } catch (err) {
      console.log('err :>> ', err);

      setRowCount(0);
      if (err.message === 'SIN_REGISTROS') {
        AlertaSinRegistros();
      }
      if (
        !err.response ||
        !err.response.data ||
        !err.response.data.codigoError
      ) {
        AlertaError(
          `Ha ocurrido un error al tratar de obtener la lista de ${diccionarioVista.primerNombrePrincipalPlural}.`
        );
      }
    } finally {
      setIsLoadingLista(false);
    }
  };

  const ObtieneGrupos = async () => {
    setIsLoadingLista(true);

    if (!logged) {
      ValidacionConexion();
      return;
    }
    const params = {
      totalPagina: DICTONARY.PAGINACION.ALL_DATA
    };
    try {
      const response = await adminService.getPermisos(params);
      if (response.status === 200) {
        const { content, totalElements, empty } = response.data;
        if (empty) {
          console.log(`No hay grupos disponibles ::>`);

          throw new Error('SIN_REGISTROS');
        } else if (Array.isArray(content)) {
          setGrupos(content);
        }
      }
    } catch (err) {
      console.log('err :>> ', err);

      if (err.message === 'SIN_REGISTROS') {
        AlertaSinRegistros();
      }
      if (
        !err.response ||
        !err.response.data ||
        !err.response.data.codigoError
      ) {
        AlertaError(
          'Ha ocurrido un error al tratar de obtener la lista de grupos.'
        );
      }
    } finally {
      setIsLoadingGrupos(false);
    }
  };

  const ObtieneListaEmpresas = useCallback(async () => {
    setIsLoadingEmpresas(true);

    try {
      const response = await empresasService.obtenerListaEmpresas({
        totalPagina: DICTONARY.PAGINACION.ALL_DATA,
        ordenarPor: 'nombreEmpresa'
      });
      // console.log('response', response);
      if (response.data.error) {
        throw new Error('ERROR_AL_CARGAR_EMPRESAS');
      }
      const empresasAux = response.data.map(empresa => ({
        codigoEmpresa: empresa.codigoEmpresa,
        nombreEmpresa: empresa.nombreEmpresa
      }));
      setEmpresas(OrdenarAscendente(empresasAux, 'nombreEmpresa'));
    } catch (error) {
      console.error('Error al cargar las empresas:', error);
      setEmpresas([]);
    } finally {
      setIsLoadingEmpresas(false);
    }
  }, []);

  return {
    // Funciones
    ObtieneListaGrupos,
    ObtieneGrupos,
    setListaGrupos,
    setGrupos,
    ObtieneListaEmpresas,
    // States Listado de Grupos y Grupos
    listaGrupos,
    grupos,
    empresas,
    empresaSeleccionada,
    // States Paginacion
    columnFilters,
    globalFilter,
    isLoadingLista,
    isLoadingGrupos,
    isLoadingEmpresas,

    pagination,
    rowCount,
    setColumnFilters,
    setGlobalFilter,
    setIsLoadingLista,
    setPagination,
    setRowCount
  };
};

export const OrdenarAscendente = (arreglo, propiedad, tipo = 'string') => {
  try {
    return arreglo.sort((a, b) => {
      if (tipo === 'string') {
        let nombreA = a[propiedad] ? a[propiedad].toUpperCase() : '-';
        let nombreB = b[propiedad] ? a[propiedad].toUpperCase() : '-';
        return nombreA < nombreB ? 1 : -1;
      }

      if (tipo === 'number') {
        return b[propiedad] - a[propiedad];
      }

      return a < b ? -1 : 1;
    });
  } catch (error) {
    //Si por algún motivo no puedo ordenar retorno el arreglo original
    return arreglo;
  }
};
